export default __webpack_public_path__ + "static/media/logo-full.320592bc.png";